import React from 'react';
import { FormattedMessage } from 'react-intl';

import Text from 'ui/Text';

const BigThreeElements = () => {
  return (
    <div className="intro-banner why-cdr">
      <Text modifiers="question-title primary-blue">
        <FormattedMessage
          id="Questionnaire.CDR.SubMenuItem.3"
          defaultMessage="Our “big 3” Capacity Elements"
        />
      </Text>
      <Text type="explanation">
        <FormattedMessage
          id="Questionnaire.CDR.BigThree.Explanation.1"
          defaultMessage={`
            Any organization needs all eight elements to function in a basic, credible manner to keep the lights on, operate legally, and make ongoing progress. However, the top three   categories act as drivers of excellence for many of the other capacities and for the overall success of an organization. As a result, the scoring for the “big three” capacity elements is higher than that of the remaining elements. The big three elements namely, Strategic Ability and Adaptability; Leadership and Governance and Financial Health and Organizational Management are attributed 15 points per category. These vital capabilities are typically the foundation on which overall organizational capacity is built. Organisations should strive to fall within the “very good” bracket on the score card. Organizations as well as their funders need to invest extra attention, energy, and resources to make sure the big three capacity elements are strong and high functioning within an organization.
          `}
        />
      </Text>
      <Text type="explanation">
        <FormattedMessage
          id="Questionnaire.CDR.BigThree.Explanation.2"
          defaultMessage={`
            The other five elements are attributed 11 points per category. This is not to say that these elements are less important than the "big three". Rather, each of these additional elements of capacity will carry a different weight for each organization depending on its typology and its specific goals, and strategy. For example, Communications, and Partnerships and Alliances are mission critical for an advocacy organization and such organizations should strive to be very good in these elements.
          `}
        />
      </Text>
    </div>
  );
};

export default BigThreeElements;


// WEBPACK FOOTER //
// ./src/components/CDRSections/BigThreeElements.js